import React from 'react';
import '../LandingPage/LandingPage.css';
import Footer from '../../Components/Footer/FooterSmall';
import Header2 from '../../Components/Header2/Header2';
import ScheduleForm from '../../Content/Forms/ScheduleForm/ScheduleForm';
import RequestInfoFrom from '../../Content/Forms/RequestInfoForm2/RequestInfoForm';

const RequestInfo: React.FC = () => {
  return (
    <div className='generalPage'>
      <Header2/>
      <div className='landingPage'>
        <RequestInfoFrom/>
      </div>
      <Footer />
    </div>

  );
};

export default RequestInfo;